import { css } from 'styled-components';
import {
  getSpacing, SpacingName, ThemedFunctor,
} from '@doveit/lego';

export const label: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.marginBottom(theme, SpacingName.SMALLEST)}
  display: inline-block;
  font-weight: bold;
`;
